import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/hero';

export default function HeroCarousel() {
  const [active, setActive] = useState(0);
  const total = heroSlides.length;

  useEffect(() => {
    const timer = setInterval(() => setActive((v) => (v + 1) % total), 6000);
    return () => clearInterval(timer);
  }, [total]);

  const goPrev = () => setActive((v) => (v - 1 + total) % total);
  const goNext = () => setActive((v) => (v + 1) % total);

  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <div className="relative h-[420px] w-full md:h-[600px]">
        {heroSlides.map((slide, index) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              index === active ? 'opacity-100' : 'pointer-events-none opacity-0'
            }`}
          >
            <img
              src={slide.image}
              alt={`${slide.title} 焦点推荐`}
              title={`${slide.title} 影视仓精选推荐`}
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/60 to-foreground-950/20" />
          </div>
        ))}

        <div className="absolute inset-0 flex items-center">
          <div className="mx-auto w-full max-w-portal px-4 md:px-6">
            <div key={active} className="max-w-xl animate-fade-in-up">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-950">
                <i className="ri-fire-fill" />
                {heroSlides[active].tag}
              </span>
              <h1 className="mt-4 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
                {heroSlides[active].title}
              </h1>
              <p className="mt-3 max-w-md text-sm leading-relaxed text-background-200 md:text-base">
                {heroSlides[active].tagline}
              </p>
              <p className="mt-3 text-xs text-background-300 md:text-sm">{heroSlides[active].meta}</p>
              <div className="mt-7 flex flex-wrap items-center gap-3">
                <Link
                  to={`/detail/${heroSlides[active].movieId}`}
                  className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-play-fill text-lg" />
                  查看详情
                </Link>
                <Link
                  to="/category/电影"
                  className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
                >
                  浏览全部
                </Link>
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          onClick={goPrev}
          aria-label="上一张"
          className="absolute left-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-background-950/40 text-background-50 backdrop-blur-sm transition-colors hover:bg-primary-500 md:flex"
        >
          <i className="ri-arrow-left-s-line text-2xl" />
        </button>
        <button
          type="button"
          onClick={goNext}
          aria-label="下一张"
          className="absolute right-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-background-950/40 text-background-50 backdrop-blur-sm transition-colors hover:bg-primary-500 md:flex md:right-6"
        >
          <i className="ri-arrow-right-s-line text-2xl" />
        </button>

        <div className="absolute bottom-5 left-1/2 flex -translate-x-1/2 items-center gap-2">
          {heroSlides.map((slide, index) => (
            <button
              key={slide.id}
              type="button"
              aria-label={`切换到第 ${index + 1} 张`}
              onClick={() => setActive(index)}
              className={`h-1.5 rounded-full transition-all duration-300 ${
                index === active ? 'w-8 bg-accent-500' : 'w-3 bg-background-50/50 hover:bg-background-50/80'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}